import {
  OptionalFieldLabel,
  StyledBanner,
} from 'modules/webPush/WebPushV2/components/Modals/styles';
import {
  BODY_LABEL,
  BROWSER_TOKEN_LABEL,
  CLICK_URL_LABEL,
  FIREBASE_CONFIGURE_SUCCESS_BANNER_CONTENT,
  ICON_LABEL,
  TEST_PUSH_INTEGRATION_HEADER,
  TITLE_LABEL,
} from 'modules/webPush/WebPushV2/constants';
import {
  useTestWebPushFormContext,
  useWebPushMetadataContext,
} from 'modules/webPush/WebPushV2/context';
import { TestWebPushModalProps } from 'modules/webPush/WebPushV2/types';
import { sendWebPushRequest } from 'modules/webPush/actions';
import { useDispatch } from 'react-redux';
import { BannerVariants } from 'ui/banner/types';
import { PrimaryButton } from 'ui/button';
import { SuccessFill16 } from 'ui/icons';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { getFormErrorMessages } from '../../utils';
import { BasicInputField } from './components/BasicInputField';

const getLabelWithOptionalText = (label: string) => (
  <>
    {label}
    <OptionalFieldLabel>{'(optional)'}</OptionalFieldLabel>
  </>
);

export const TestWebPushModal = ({
  onClose,
  fileName,
  isTestingLater = false,
}: TestWebPushModalProps) => {
  const dispatch = useDispatch();

  const { formState, getValues, handleSubmit } = useTestWebPushFormContext();
  const { integration } = useWebPushMetadataContext();

  const errorMessages = getFormErrorMessages(formState.errors);

  const handleSend = handleSubmit(() => {
    if (!integration) return;
    dispatch(sendWebPushRequest({ ...getValues(), pushConfig: integration }));
    onClose();
  });

  return (
    <Modal id="web-push-integration-test-push-modal" isModalOpen onClose={onClose}>
      <ModalHeader>{TEST_PUSH_INTEGRATION_HEADER}</ModalHeader>
      <ModalBody>
        {!isTestingLater && fileName && (
          <StyledBanner variant={BannerVariants.SUCCESS} Icon={<SuccessFill16 />}>
            {FIREBASE_CONFIGURE_SUCCESS_BANNER_CONTENT(fileName)}
          </StyledBanner>
        )}
        <BasicInputField
          errorText={errorMessages.browserToken}
          labelText={BROWSER_TOKEN_LABEL}
          name="browserToken"
        />
        <BasicInputField errorText={errorMessages.title} labelText={TITLE_LABEL} name="title" />
        <BasicInputField errorText={errorMessages.body} labelText={BODY_LABEL} name="body" />
        <BasicInputField
          errorText={errorMessages.icon}
          labelText={getLabelWithOptionalText(ICON_LABEL)}
          name="icon"
        />
        <BasicInputField
          errorText={errorMessages.clickAction}
          labelText={getLabelWithOptionalText(CLICK_URL_LABEL)}
          name="clickAction"
        />
      </ModalBody>
      <ModalFooter cancelLabel={isTestingLater ? 'Cancel' : 'Send test later'}>
        <PrimaryButton onClick={handleSend}>Send test</PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
